module.exports = __webpack_public_path__ + "img/erp_case5.87c3eed0.png";